import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'
import { ShiftBadge } from '../components/ShiftBadge'

export type ShiftReplacedProps = BaseNotificationItemProps & {
  userName: string
  originalUserName: string
  originalShiftId: string
  replacementShiftId: string
  originalShift: {
    start: string
    end: string
  }
  replacementShift?: {
    start: string
    end: string
  }
  demotedShiftEndTime?: string
  type: 'shift_replaced'
}

export function ShiftReplaced({
  userName,
  originalUserName,
  originalShiftId,
  replacementShiftId,
  originalShift,
  replacementShift,
  demotedShiftEndTime,
  ...props
}: ShiftReplacedProps) {
  return (
    <NotificationItem
      {...props}
      title={`${userName} Claimed the Replacement Shift`}
      descriptionAddon={
        <div className='flex flex-col text-sm text-gray-500'>
          <p>Original Operator: {originalUserName}</p>
          <p className='mt-1'>Replacement Operator: {userName}</p>
          <p className='mt-1'>
            Original Shift:{' '}
            <ShiftBadge
              id={originalShiftId}
              startDate={originalShift.start}
              endDate={originalShift.end}
              inactivityTime={demotedShiftEndTime}
              timezonePreference={props.timezonePreference}
            />
          </p>
          <p className='mt-1'>
            Replacement Shift:{' '}
            <ShiftBadge
              id={replacementShiftId}
              startDate={replacementShift?.start}
              endDate={replacementShift?.end}
              timezonePreference={props.timezonePreference}
            />
          </p>
        </div>
      }
    />
  )
}
